/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.watch.later.bff.rpc.WatchLaterBFFChirpService
 */

export const getItemsForWatchLaterPageRpc = {
  serviceName: 'com.hubspot.watch.later.bff.rpc.WatchLaterBFFChirpService',
  rpcName: 'getItemsForWatchLaterPage',
  auth: 'app',
  fingerprint: 'rVchXgD28o9-UetkcikOmk2MB044iw8k',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};